import CustomHeading from 'components/CustomHeading'
import { Images } from 'constants'
import { svgs, casinoData } from 'constants'
import React from 'react'
import { Link } from 'react-router-dom';

const AllProviders = () => {
    const liveCasino = casinoData.find(cat => cat.category_name.trim() === 'Live Casino');
    const virtualCasino = casinoData.find(cat => cat.category_name.trim() === 'Virtual Casino');

    const sports_game = [
        { game: 'cricket', url_thumb: Images.CRICKET },
        { game: 'soccer', url_thumb: Images.SOCCER },
        { game: 'tennis', url_thumb: Images.TENNIS },
        { game: 'kabaddi', url_thumb: Images.KABADDI },
        { game: 'cup_winner', url_thumb: Images.CUP_WINNER },
        { game: 'politics', url_thumb: Images.POLITICS },
    ]

    const Heading = ({ text, url }) => {
        return (
            <div className={`w-full sm:w-[390px] mt-2 px-2 h-[30px]`}>
                <div className={`flex w-full !text-[14px] text-[#0052AF] font-[400] justify-between`}>
                    <div className='flex items-center px-1'>
                        {text && <span className='pr-1'>{text}</span>}
                        <span>{svgs.down_arrow_blue}</span>
                    </div>
                    <Link to={url} className='flex items-center capitalize'>
                        <span className='mr-1'>
                            View All
                        </span>
                        {svgs.right_arrow_blue}
                    </Link>
                </div>
            </div >
        )
    }

    const CustomHr = () => (
        <div className='w-full h-[4px]' style={{
            background: "linear-gradient(180deg, #4A0000 16.34%, #064955 91.4%)"
        }} />
    )


    return (
        <div>
            <CustomHeading svg={svgs.all_providers} text={"AllProviders"} down_icon={true} redirect={false} type={1} />
            <Heading text={"SPORTS GAME"} url={'/all-sports'} />
            <CustomHr />
            <div className='w-full flex items-center overflow-auto scrollbar-hide my-[2px]'>
                {sports_game.map((item, index) => (
                    <div key={index} className='rounded-lg mr-1 w-[110px] h-[80px] flex-shrink-0'>
                        <img src={item.url_thumb} alt={`Banner ${index + 1}`} className='w-full h-full rounded-lg' />
                    </div>
                ))}
            </div>
            <CustomHr />
            <Heading text={"LIVE CASINO"} url={'/all-casino/?type=1'} />
            <CustomHr />
            <div className='w-full flex items-center overflow-auto scrollbar-hide my-[2px]'>
                {liveCasino?.data.map((item, index) => (
                    <div key={index} className='rounded-lg mr-1 w-[110px] h-[80px] flex-shrink-0'>
                        <img src={item.url_thumb} alt={`Banner ${index + 1}`} className='w-full h-full rounded-lg' />
                    </div>
                ))}
            </div>
            <CustomHr />
            <Heading text={"VIRTUAL CASINO"} url={'/all-casino/?type=2'} />
            <CustomHr />
            <div className='w-full flex items-center overflow-auto scrollbar-hide my-[2px]'>
                {virtualCasino?.data.map((item, index) => (
                    <div key={index} className='rounded-lg mr-1 w-[110px] h-[80px] flex-shrink-0'>
                        <img src={item.url_thumb} alt={`Banner ${index + 1}`} className='w-full h-full rounded-lg' />
                    </div>
                ))}
            </div>
            <CustomHr />
        </div>
    )
}

export default AllProviders